import { createFileRoute } from "@tanstack/react-router";
import AdminPartsContent from "@/pages/admin/AdminPartsContent";

export const Route = createFileRoute("/_adminLayout/admin/parts/content/")({
  component: AdminPartsContent,
});